import React, { useEffect, FC } from "react";
import styled from "styled-components";

// Local imports
import logo from "./xiQ-logo.png";
import Error400 from "../../../assets/img/Permission/400-error.svg"
import Error401 from "../../../assets/img/Permission/401-error.svg"
import Error403 from "../../../assets/img/Permission/403-error.svg"
import Error404 from "../../../assets/img/Permission/404-error.svg"
import Error408 from "../../../assets/img/Permission/408-error.svg"
import Error500 from "../../../assets/img/Permission/500-error.svg"
import Error503 from "../../../assets/img/Permission/503-error.svg"
import { getQueryParam } from "utils";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { resetErrorAction } from "modules/Error/actions";
import GlobalStyle from "GlobalStyle";

interface INoDataFound {
  message?: string;
}

interface ErrorObj {
  logo: string
  title: string
  isReload: boolean
  contactus: boolean
  description: string
}

interface Root {
  "400": ErrorObj,
  "401": ErrorObj,
  "403": ErrorObj,
  "404": ErrorObj,
  "408": ErrorObj,
  "500": ErrorObj,
  "503": ErrorObj
}


const errorObj: Root = {
  "400": {
    logo: Error400,
    title: "400 Bad Request",
    isReload: false,
    contactus: false,
    description: "Your client has issued a mailformed or illegal request",
  },
  "401": {
    logo: Error401,
    title: "401 Authorization Required",
    isReload: false,
    contactus: true,
    description: "",
  },
  "403": {
    logo: Error403,
    title: "403 Permission Denied",
    isReload: false,
    contactus: true,
    description: "You do not have permission to view this screen",
  },
  "404": {
    logo: Error404,
    title: "404 Page not found",
    isReload: false,
    contactus: false,
    description: "The page you are trying to access does not exits or has been deleted",
  },
  "408": {
    logo: Error408,
    title: "408 Request Time Out",
    isReload: true,
    contactus: false,
    description: "Request is taking too long to process",
  },
  "500": {
    logo: Error500,
    title: "500 Internal Server Error",
    isReload: false,
    contactus: false,
    description: "Server is unable to process this request",
  },
  "503": {
    logo: Error503,
    title: "503 Service Unavailable",
    isReload: false,
    contactus: false,
    description: "Service is temporarily unavailable. Try again later!",
  }
}

const PermissionDenied: FC<INoDataFound> = (props) => {
  const history = useHistory()
  const error: string = getQueryParam('error')
  const redirect = useSelector((state: RootState) => state.errors.redirectUrl)

  let errorObjMap: ErrorObj | null = null
  if (error) {
    errorObjMap = errorObj[error as keyof typeof errorObj]
  }

  const redirectToNavigator = () => {
    if (errorObjMap?.isReload) history.go(-1)
    else history.push(redirect !== "" ? redirect : "/campaigns")
    resetErrorAction()
  }

  useEffect(() => {
    return () => {
      // && history.location.pathname === "any specific path")
      if (history.action === "POP") {
        history.replace(redirect !== "" ? redirect : "/campaigns");
        setTimeout(() => {
          resetErrorAction();
        }, 2000);
      }
    };
  }, [history])

  return (
    <Wrapper>
      <GlobalStyle />
      <nav className="navbar navbar-light bg-light navbar">
        <a className="navbar-brand nav_bar" href="javascript: void(0);">
          <img className="logo" alt="logo" src={logo} width="60" height="60" />
        </a>
      </nav>
      <div className="content-box d-flex flex-column ">
        <h1 className="no-data-div hd1">{errorObjMap?.title}</h1>
        <p className="no-data-div txt"> {errorObjMap?.description}</p>
        {errorObjMap?.contactus &&
          <p className="no-data-div txt2">
            Please contact us at
            <strong>
              <a href={`mailto:support@xiqinc.com`} className="supportLink">
                {` support@xiqinc.com `}
              </a>
            </strong>
            for further assistance
          </p>
        }

        <img src={errorObjMap?.logo} alt="bot" className="centered" />
        <span onClick={() => redirectToNavigator()} className="btn btn-success centered_btn"
          role="button" aria-pressed="true"
        >
          {errorObjMap?.isReload ? "Try Again" : "Go Back"}
        </span>
      </div>
    </Wrapper>
  );
};

export default PermissionDenied;

const Wrapper = styled.div`
  background-color: #f9f8f6;
  height: 100vh;
  .content-box {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 300px);
  }
  .hd1 {
    margin-top: 20px;
    font-size: 40px;
    font-weight: 600;
    font-family: "Roboto Slab", sans-serif;
  }
  .navbar {
    -webkit-box-shadow: 0px 0px 30px 2px rgb(0 0 0 / 20%);
    -moz-box-shadow: 0px 0px 30px 2px rgb(0 0 0 / 20%);
    box-shadow: 0px 0px 30px 2px rgb(0 0 0 / 20%);
    background-color: #fff;
    height: 120px;
  }
  .no-data-div {
    width: 100%;
    text-align: center;
    font-family: "Roboto", sans-serif Slab;
  }
  .txt {
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 0px;
    line-height: 1;
    color: #001823;
    margin-bottom: 5px;
  }
  .txt2 {
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 1;
    margin-bottom: 50px;
    color: #001823;
  }
  .nav_bar {
    margin-left: 20px;
  }
  .supportLink {
    color: rgb(51, 226, 51);
  }
  .centered {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 12%;
  }
  .centered_btn {
    margin-top: 35px;
    background-color: #1ec252 !important;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 106px;
    height: 36px;
    border-color: #1ec252;
    font-family: "robotomedium", sans-serif;
    font-weight: 700;
    padding: 0.375rem 0.5rem;
    border-radius: 8px;
  }
`;
